import React from 'react';
import { Button, Modal } from 'semantic-ui-react';

type Props = {
  open: boolean;
  loading?: boolean;
  title?: string;
  content?: string;
  confirmLabel?: string;
  confirmNegative?: boolean;
  onCancel: () => void;
  onConfirm: () => void;
};

const ConfirmSaveModal = ({
  open,
  loading,
  title = 'Применить изменения?',
  content = 'Сохранить внесённые изменения?',
  confirmLabel = 'Сохранить',
  confirmNegative = false,
  onCancel,
  onConfirm,
}: Props) => (
  <Modal open={open} size="tiny" onClose={onCancel}>
    <Modal.Header>{title}</Modal.Header>
    <Modal.Content>
      <p>{content}</p>
    </Modal.Content>
    <Modal.Actions>
      <Button onClick={onCancel} disabled={!!loading}>
        Отмена
      </Button>
      <Button
        primary={!confirmNegative}
        negative={confirmNegative}
        loading={!!loading}
        onClick={onConfirm}
      >
        {confirmLabel}
      </Button>
    </Modal.Actions>
  </Modal>
);

export default ConfirmSaveModal;
